import React, { useState, useEffect } from "react";
import Button from "../../controls/Button";
import CustomDrawer from "../../controls/CustomDrawer";
import Input from "../../controls/Input";
import { toast } from "react-toastify";
import { handleAddBrand, handleEditBrand } from "../../../api/brandApi";
import Loading from "../../controls/Loading";

function AddBrand({ closeDrawer, onSave, editData = {} }) {
  const [brand, setBrand] = useState(editData.Brand || "");
  const [brandError, setBrandError] = useState("");
  const [loading, setLoading] = useState(false);

  // Initialize form data based on editData





  const handleSaveClick = async () => {
    if (brand.trim() == "") {
      setBrandError("Please Enter Brand !");
      return;
    }

    const payload = {
      Brand: brand,
      IsDeleted:false,
      ...(editData.key && { key: editData.key }),
    };
    console.log("payloaddata--", payload)

    setLoading(true);
    try {
      let response = null;

      if (editData?.key) {
        response = await handleEditBrand(payload);
      } else {
        response = await handleAddBrand(payload);
      }
      console.log("response", response);
      if (response?.code == "0") {
        toast.success(
          editData?.key
            ? "Brand updated successfully"
            : "Brand added successfully"
        );
        //  onSave(response.brand);
          onSave(response?.brand);
        closeDrawer(false);
      
      } else {
        const errorMessage = response?.message || "Failed to save brand";
        console.error("Failed to save brand:", errorMessage, response);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Runtime error while saving category:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomDrawer
      setDrawer={closeDrawer}
      drawerWidth="sm:w-[500px]"
      title={editData?.key ? "Edit Brand" : "Add Brand"}
      buttons={[
        { Label: "Cancel", Type: "secondary", Icon: "roundedRemove" },
        { Label: "Save", Type: "primary", Icon: "save" },

      ]}
      onButtonClick={(label) => {
        if (label === "Save") {
          handleSaveClick();
        } else if (label === "Cancel") {
          closeDrawer(false)
        }
      }}
    >
      {loading ? (
        <Loading />
      ) : (
        <Input
          isMandatory={true}
          label="Brand Name"
          placeholder="Enter Brand Name"
          type="text"
          value={brand}
          onChange={(e) => { setBrand(e.target.value), setBrandError("") }}
          errorMessage={brandError}
        />
      )}
    </CustomDrawer>
  );
}

export default AddBrand;
